/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/KeyboardBackspace';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const KeyboardBackspaceIcon = withMuiAdapter(Base, 'KeyboardBackspace');
